'use strict';

function PageLoading() {

    var spinner = $('#spinner');
    var fadedClass = 'faded';
    var self = this;
    var ignore_onbeforeunload = false;

    /********************************/
    // Show page loading spinner
    /********************************/
    this.initPageLoading = function () {
        $('.loader, #dvLoading').fadeOut('slow');


        $('a[href^=mailto], a[href*="SIW_FILE_LOAD"], a[href*=".pdf"],a[href*=".PDF"],a[href*=".Pdf"], a[href *= ".doc"], a[href *= ".DOC"], a[href *= ".Doc"],a[href *= ".docx"], a[href *= ".DOCX"], a[href *= ".Docx"],a[href *= ".dot"], a[href *= ".DOT"], a[href *= ".Dot"],a[href *= ".dotx"], a[href *= ".DOTX"], a[href *= ".Dotx"],a[href *= ".xls"], a[href *= ".XLS"], a[href *= ".Xls"],a[href *= ".xlsx"], a[href *= ".XLSX"], a[href *= ".Xlsx"],a[href *= ".pps"], a[href *= ".PPS"], a[href *= ".Pps"],a[href *= ".ppt"], a[href *= ".PPT"], a[href *= ".Ppt"],a[href *= ".pptx"], a[href *= ".PPTX"], a[href *= ".Pptx"],a[href *= ".pot"], a[href *= ".POT"], a[href *= ".Pot"],a[href *= ".zip"], a[href *= ".ZIP"], a[href *= ".Zip"],a[href *= ".mp3"], a[href *= ".MP3"], a[href *= ".Mp3"],a[href *= ".mp4"], a[href *= ".MP4"], a[href *= ".Mp4"],a[href *= ".mov"], a[href *= ".MOV"], a[href *= ".Mov"],a[href *= ".vsd"], a[href *= ".VSD"], a[href *= ".Vsd"]').on('click', function () {
                ignore_onbeforeunload = true;
                $(this).addClass('spinner-disabled');
            }
        );

        if ($('input[name="VIEW.FNR.SRS."]').length === 0) {
            $(window).off('beforeunload');

            $(window).on('beforeunload', function (event) {
                if (ignore_onbeforeunload === false) {
                    setTimeout(function () {
                        self.showPageLoading();
                    }, 0);
                }
                ignore_onbeforeunload = false;
            });
        }

        $('#exit-spinner').click(function (event) {
            self.hidePageLoading();
        });

        $(document).off('keyup');
        $(document).on('keyup', function (e) {
            if (e.keyCode === 27) {
                self.hidePageLoading();
            }
        });

        /*$('body').click(function () {
            self.hidePageLoading();
        });*/
    }
    ;

    /********************************/
// Show page loading spinner
    /********************************/
    this.showPageLoading = function () {
        $('body').addClass(fadedClass);
        spinner.show();
    };

    /********************************/
// Hide page loading spinner
    /********************************/
    this.hidePageLoading = function () {
        $('body').removeClass(fadedClass);
        spinner.hide();
    };
}
